import React from "react";
import moment from "moment";
import { Card, List, Avatar, Skeleton } from "antd";
import { useLoanRepayments } from "@/hooks/loans/useLoans";
import { useTransactionList } from "@/hooks/accounts/useCustomerAccount";
import { format } from "@/components/common/utils/money";
import {AuthUser, TransactionDTO} from "@/shared/api/model";

interface TransactionsProps {
    authUser: AuthUser;
}

const LoanTransactions: React.FC<TransactionsProps> = ({ authUser }) => {
   console.log(authUser);
    const { branch, custNo } = authUser;
    // @ts-ignore
    const [transactionsQuery] = useLoanRepayments(branch, custNo);
    const { isLoading, error, data } = transactionsQuery;

    if (isLoading) return <Skeleton active />;

    if (error) return <div>An error has occurred: {error.message}</div>;

    return (
        <List
            className="yestday transactions-list"
            header={<h6>Recent Loan Transactions</h6>}
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item: TransactionDTO) => (
                <List.Item>
                    <List.Item.Meta
                        avatar={<Avatar size="small" className="text-success">-</Avatar>}
                        title={item.productName}
                        description={`${item.narration} (${moment(item.trxDate).format("DD MMM, yyyy ddd")})`}
                    />
                    <div className="amount">
            <span className="text-success">
              {format(Number(item.principal) + Number(item.interest))}
            </span>
                    </div>
                </List.Item>
            )}
        />
    );
};

const AssetTransactions: React.FC<TransactionsProps> = ({ authUser }) => {
    const { branch, custNo } = authUser;
    // @ts-ignore
    const [transactionQuery] = useTransactionList(branch, custNo, "");
    const { isLoading, isError, data } = transactionQuery;

    if (isLoading) return <Skeleton active />;

    if (isError) return <div>Something went wrong</div>;

    return (
        <List
            header={<h6>Recent Savings And Shares Transactions</h6>}
            className="transactions-list ant-newest"
            itemLayout="horizontal"
            dataSource={data}
            renderItem={(item: TransactionDTO) => (
                <List.Item>
                    <List.Item.Meta
                        avatar={
                            <Avatar size="small" className={item?.amount || 0 > 0 ? "text-light-danger" : "text-fill"}>
                                {item?.amount || 0 > 0 ? "+" : "-"}
                            </Avatar>
                        }
                        title={item.productName}
                        description={`${item.narration} (${moment(item.trxDate).format("DD MMM, yyyy ddd")})`}
                    />
                    <div className="amount">
            <span className={item?.amount || 0 > 0 ? "text-danger" : "text-success"}>
              {format(item.amount || 0)}
            </span>
                    </div>
                </List.Item>
            )}
        />
    );
};

const YourTransaction: React.FC<TransactionsProps> = ({ authUser }) => {
    return (
        <Card
            bordered={false}
            bodyStyle={{ paddingTop: 0 }}
            className="header-solid h-full ant-list-yes"
            title={<h6 className="font-semibold m-0">Your Transactions</h6>}
            extra={<p className="card-header-date"><span></span></p>}
        >
            <AssetTransactions authUser={authUser} />
            <LoanTransactions authUser={authUser} />
        </Card>
    );
};

export default YourTransaction;